import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.USER };

const path = "/user/user"

export const editProfile = async (values) => {
  return await axiosInstance(options).put(`${path}/edit-profile`, values);
};


export const profileDetails = async (values) => {
  return await axiosInstance(options).get(`${path}/get-user-details?_id=${values._id}`);
};

export const sendUpdateOtp = async (values) => {
  return await axiosInstance(options).post(`${path}/send-update-otp`, values);
};

export const verifyUpdateOtp = async (values) => {
  return await axiosInstance(options).put(`${path}/verify-update-otp`, values);
};


export const deleteProfile = async (values) => {
  return await axiosInstance(options).delete(`${path}/delete-account?_id=${values._id}`, values);
};

export const updaterNotificationSetting = async (values) => {
  return await axiosInstance(options).patch(`${path}/update-notification-setting`, values);
};

export const updateUserPassword = async (values) => {
  return await axiosInstance(options).patch(`${path}/update-user-password`, values);
};

export const becomeAdvertiser = async (values) => {
  return await axiosInstance(options).patch(`${path}/become-advertiser`, values);
};

// Staff Invitation APIs (Public & Protected)
export const getInvitationDetails = async (token) => {
  // Public endpoint
  return await axiosInstance({ role: ROLE.USER }).get(`${path}/invitation-details?token=${token}`);
};

export const respondInvitationPublic = async (values) => {
  // Public endpoint
  return await axiosInstance({ role: ROLE.USER }).post(`${path}/respond-invitation-public`, values);
};

export const getMyInvitations = async () => {
  // Protected endpoint
  return await axiosInstance(options).get(`${path}/my-invitations`);
};

export const respondInvitation = async (values) => {
  // Protected endpoint
  return await axiosInstance(options).post(`${path}/respond-invitation`, values);
};

export const toggleFavouriteSeller = async (seller_id) => {
  return await axiosInstance(options).post(`${path}/add-remove-favourite-streamer`, { seller_id });
};
